module.exports = __webpack_public_path__ + "img/d8.67b5d4cc.png";